(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vv-style-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.vvCardSlider) return;
    window.vvCardSlider = true;
    var update = function (track) {
      var slider = track.closest('[data-vv-slider]');
      if (!slider) return;
      var w = track.clientWidth || 1;
      var count = track.children.length;
      var i = Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / w)));
      slider.dataset.index = i;
      if (i >= count - 1) slider.setAttribute('data-last', '');
      else slider.removeAttribute('data-last');
      var bar = slider.querySelector('[data-vv-bar]');
      if (bar) bar.style.transform = 'translateX(' + i * 100 + '%)';
    };
    document.addEventListener(
      'scroll',
      function (e) {
        var t = e.target;
        if (t && t.hasAttribute && t.hasAttribute('data-vv-track')) update(t);
      },
      true
    );
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest && e.target.closest('[data-vv-slide]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var track = btn.closest('[data-vv-slider]').querySelector('[data-vv-track]');
        track.scrollBy({ left: track.clientWidth * Number(btn.dataset.vvSlide), behavior: 'smooth' });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vv-wish-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.vvWishlist) return;
    var KEY = 'vv-wishlist';
    var read = function () {
      try {
        var v = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Array.isArray(v) ? v : [];
      } catch (e) {
        return [];
      }
    };
    var write = function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 100))); } catch (e) {}
    };
    var sync = function (root) {
      var list = read();
      (root || document).querySelectorAll('[data-vv-wish]').forEach(function (b) {
        var on = list.indexOf(b.getAttribute('data-vv-wish')) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('[data-vv-wish-count]').forEach(function (el) {
        el.textContent = list.length;
        el.hidden = list.length === 0;
      });
    };
    window.vvWishlist = {
      get: read,
      has: function (h) { return read().indexOf(h) > -1; },
      toggle: function (h) {
        var list = read();
        var i = list.indexOf(h);
        if (i > -1) list.splice(i, 1);
        else list.unshift(h);
        write(list);
        sync();
        document.dispatchEvent(new CustomEvent('vv:wishlist', { detail: { handle: h, saved: i === -1, list: list } }));
        return i === -1;
      },
      sync: sync,
    };
    document.addEventListener(
      'click',
      function (e) {
        var b = e.target.closest && e.target.closest('[data-vv-wish]');
        if (!b) return;
        e.preventDefault();
        e.stopPropagation();
        window.vvWishlist.toggle(b.getAttribute('data-vv-wish'));
        b.classList.remove('is-pop');
        void b.offsetWidth;
        b.classList.add('is-pop');
      },
      true
    );
    window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); });
    else sync();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; sync(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
